import React from "react"
import { Modal } from "semantic-ui-react"

const ModalComponent = ({ modalState, closeAction, configs, ModalContent }) => {
  const content =
    configs.for === "ProductPage" ? (
      <ModalContent stockId={configs.stockId} settings={configs.settings} />
    ) : (
      ""
    )

  return (
    <Modal open={modalState} onClose={closeAction}>
      <Modal.Content>{content}</Modal.Content>
    </Modal>
  )
}

export default ModalComponent
